
import Intersect from 'vue-intersect';
import FlipCountdown from 'vue2-flip-countdown';
import CampaignsMixin from '~/mixins/campaigns';

export default {
  components: {
    FlipCountdown,
    Intersect,
  },
  mixins: [CampaignsMixin],
  props: {
    more: {
      type: String,
      required: true,
    },
    component: {
      type: Object,
      required: true,
    },
    startDate: {
      type: String,
      required: false,
      default: null,
    },
    endDate: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isIntersected: false,
    };
  },
  computed: {
    deadline() {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);

      if (!this.started && !this.ended) {
        return start.toLocaleString('en-us', {
          year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
        }).replace(/,/g, '');
      }

      if (this.started) {
        return end.toLocaleString('en-us', {
          year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
        }).replace(/,/g, '');
      }

      return null;
    },
    started() {
      const { now } = this;
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);

      if (this.startDate) {
        if (now >= start && now < end) {
          return true;
        }
      } else if (now < end) {
        return true;
      }

      return false;
    },
    ended() {
      const { now } = this;
      const end = new Date(this.endDate);

      return (now > end);
    },
    direction() {
      if (!this.started) {
        return 'Starts';
      }

      return 'Ends';
    },
    cssVariables() {
      if (!this.isIntersected) {
        return {};
      }

      return {
        '--background-image': `url(${this.component.background})`,
        '--mobile-background-image': `url(${this.component.mobile_background || this.component.background})`,
      };
    },
  },
};
